import React from 'react';
import { Box, Button } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

const ResizeButton = ({ handleResize, isResizing, selectedFiles, currentSize }) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button 
                variant="contained"
                onClick={handleResize}
                disabled={isResizing || selectedFiles.length === 0 || !currentSize}
                startIcon={<ImageIcon />}
                sx={{
                    mt: 2, 
                    backgroundColor: "green",
                    color: "white",
                    "&:hover": { backgroundColor: "darkgreen" }
                }}
            >
                {isResizing ? "処理中..." : "リサイズ開始"}
            </Button>
        </Box>
    );
};

export default ResizeButton;
